// 快递存，输入取件人手机号
<template>
  <div class="importPhone">
    <!-- 流程 -->
    <expressSaveFlow :index="3"></expressSaveFlow>

    <div class="input-wrapper">
      <el-input
        ref="input"
        class="input"
        placeholder="请输入取件人手机号"
        v-model="keyWord"
        maxlength="11"
        autofocus>
      </el-input>
      <i class="close el-icon-error" v-show="keyWord.length != 0" @click="clearKeyWord"></i>
      <span class="name" v-if="keyWord.length == 11 && NewItems != 0">{{NewItems[0].user_name}}</span>
    </div>
      <div class="fuzzy-search">
        <p class="tit" v-if="NewItems.length > 0 && NewItems.length <= 2 && keyWord.length != 11">您可能想投递至</p>
        <ul class="name-list" v-if="NewItems.length > 0 && NewItems.length <= 2 && keyWord.length != 11">
          <li class="text"
            v-show="keyWord.length != 0"
            v-for="(item) in NewItems"
            :key="item.user_id"
            @click="selectSelectUser(item)">{{item.user_name}}</li>
        </ul>
      </div>
    <el-button type="primary" class="btn-confirm" @click="goScanExpressCode">确定</el-button>

    <!-- 上一步 -->
    <span class="turnoverCabinet-btn-back" v-show="$store.state.isShowRBot" @click="back">上一步</span>
  </div>
</template>

<script>
import expressSaveFlow from '../expressSave/expressSaveFlow'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showToast } from '../../../../static/turnoverCabinet/js/utility'

export default {
  name: 'importPhone',
  components: {
    expressSaveFlow
  },
  data () {
    return {
      left: '',
      keyWord: '',
      items: []
    }
  },
  created () {
    // this.$store.state.apitoken = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1NjQ3Mjg1NjcsImlhdCI6MTU2NDcyNDk2NywibmJmIjoxNTY0NzI0OTY3LCJqdGkiOiJlYWQ5NjAwOTMxZTc4NGMzYTNhMWI2M2JkOWYxN2Y3OCIsInN1YiI6IjUifQ.f0369b52c9a24d8373400bdafa714a7603edeecdc3970df25e26ab995ce421e7'
    this.getUserByPhone()
  },
  mounted () {
    // 计算
    let inputWrapperWidth = document.getElementsByClassName('input-wrapper')[0].clientWidth
    this.left = inputWrapperWidth / 2 + 170
  },
  computed: {
    // 计算匹配姓名
    NewItems () {
      let _this = this
      let NewItems = []
      this.items.map(function (item) {
        // console.log(item.phone_no)
        if (String(item.phone_no).search(_this.keyWord) !== -1) {
          NewItems.push(item)
        }
      })
      console.log(NewItems)
      return NewItems
    }
  },
  methods: {
    // 获取所有用户列表
    async getUserByPhone () {
      let vm = this
      let data = {
        // key_word: '',
        // department_id: ''
      }

      let res = await cabinetApi.getUserByPhone(data)
      if (res.meta.code === 200) {
        this.items = res.data
      } else {
        showToast (res.meta.message)
      }
    },
    // 选择搜索用户
    selectSelectUser (item) {
      this.keyWord = item.phone_no
    },
    // 清除关键字
    clearKeyWord () {
      this.keyWord = ''
      this.$refs.input.focus()
      
    console.log('height', window.innerHeight)
    },
    // 跳转到扫描快递条码页面
    goScanExpressCode: function () {
      if (this.keyWord === '') {
        showToast('请输入取件人手机号!')
        return
      } else if (this.keyWord.length !== 11) {
        showToast('手机号不足11位!')
        return
      }
      if (this.NewItems.length == 0) {
        showToast('暂无此用户')
        return
      }

      // 确认投递参数 --- 取件人
      this.$store.state.deliverData.user_id = this.NewItems[0].user_id
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet/scanExpressCode'
      })
    },
    // 返回上一页  （选择箱格）
    back () {
      this.$router.push('/turnoverCabinet/selectCell')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.importPhone{
  width: 100%;
}

/* input框 */
.importPhone .input-wrapper{
  width: 7.92rem;
  height: 1.2rem;
  margin: 0 auto;
  margin-top: 1.3rem;
  position: relative;
}

.importPhone .input{
  display: block;
  /* height: 1.2rem !important;
  line-height: 1.2rem !important; */
}

.importPhone .input-wrapper .name {
  color: #999999;
  font-size: 0.3rem;
  line-height: 1.2rem;
  position: absolute;
  top: 0;
  right: 1.1rem;
}

.importPhone .input-wrapper .close {
  height: 0.45rem;;
  color: #d8d8d8;
  font-size: 0.45rem;
  position: absolute;
  right: 0.3rem;
  top: 0;
  bottom: 0;
  margin: auto;
}

.importPhone .btn-confirm{
  display: block;
  width: 4.56rem;
  margin: 0 auto;
  height: 1.82rem;
  line-height: 1.82rem;
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0;
  background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
  background: linear-gradient(to top,#076abf, #4cacff);
  box-shadow: #2c4b64 0px 0px 0.2rem;
}

/* // 模糊搜索 */

.importPhone .fuzzy-search {
  height: 1.9rem;
  text-align: center;
}

.importPhone .fuzzy-search .tit {
  font-size: 0.24rem;
  line-height: 0.8rem;
}

.importPhone .fuzzy-search .name-list{
  color: #333333;
  font-size: 0.34rem;
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
}

.importPhone .fuzzy-search .name-list .text {
  flex-shrink: 0;
  margin-right: 0.3rem;
  padding: 0 0.18rem;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.3rem;
  border: 1px solid #ffffff;
  border-radius: 0.05rem;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/expressSave/importPhone.vue